/*!
 * extract-comments <https://github.com/jonschlinkert/extract-comments>
 *
 * Copyright (c) 2014-present Jon Schlinkert.
 * Licensed under the MIT license.
 */
'use strict';

var _classCallCheck = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var esprima = require('esprima-extract-comments');

var BlockComment = require('./block');

var LineComment = require('./line');

var Context = require('./context');
/**
 * If you need to customize the generated comment objects, you
 * can create an instance of `Extractor`:
 *
 * ```js
 * const extract = require('extract-comments');
 * const Extractor = extract.Extractor;
 * const comments = new Extractor(options);
 * ```
 * @param {String} `string`
 * @param {Object} `options`
 * @param {Object} `options.first` Return the first comment only
 * @param {Object} `options.banner` alias for `options.first`
 * @param {Function} `fn` Optionally pass a transform function to call on each token (comment) in the AST.
 * @return {String}
 * @api public
 */


var Extractor =
/*#__PURE__*/
function () {
  function Extractor(options, fn) {
    _classCallCheck(this, Extractor);

    if (typeof options === 'function') {
      fn = options;
      options = {};
    }

    this.options = Object.assign({
      transform: fn
    }, options);
  }

  _createClass(Extractor, [{
    key: "extract",
    value: function extract(str) {
      if (typeof str !== 'string') {
        throw new TypeError('expected a string');
      }

      var opts = Object.assign({
        keepProtected: true
      }, this.options);
      var extract = opts.extractor || esprima;
      var tokens = extract(str, opts);
      var comments = [];
      var filter = opts.filter;
      var keep = opts.stripProtected === true ? false : opts.keepProtected === true;

      for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        var nextToken = tokens[i + 1];

        if (typeof filter === 'function' && filter(token) === false) {
          continue;
        }

        if (/^\*?!/.test(token.value) && keep === false) {
          continue;
        }

        var comment = toComment(str, token, nextToken, opts);
        if (comment) comments.push(comment);

        if ((opts.first || opts.banner) && comments.length === 1) {
          break;
        }
      }

      return comments;
    }
  }]);

  return Extractor;
}();

function toComment(str, token, nextToken, options) {
  if (typeof options.transform === 'function') {
    token = options.transform(token, options) || token;
  }

  if (isBlock(token.type) && options.block !== false) {
    var comment = new BlockComment(str, token, options);
    if (nextToken) nextToken = toComment(str, nextToken, null, options);
    comment.code = new Context(str, comment, nextToken, options);
    return comment;
  }

  if (isLine(token.type) && options.line !== false) {
    return new LineComment(str, token, options);
  }
}

function isLine(type) {
  return type === 'Line' || type === 'CommentLine' || type === 'LineComment';
}

function isBlock(type) {
  return type === 'Block' || type === 'CommentBlock' || type === 'BlockComment';
}
/**
 * Expose `Extractor` constructor
 */


module.exports = Extractor;